import { createAsyncThunk } from '@reduxjs/toolkit';

import * as services from './services';

export const fetchWallet = createAsyncThunk('wallet/fetch', (id: string) =>
  services.fetchWallet(id)
);
